// extracted by mini-css-extract-plugin
export var active = "_48-7";
export var container = "_48-0";
export var evenWidth = "_48-4";
export var large = "_48-5";
export var outlet = "_48-8";
export var slide = "_48-2";
export var small = "_48-6";
export var tab = "_48-3";
export var tabs = "_48-1";